/*
 * formatEuro formats value to a currency string with
 * two fraction digits and a € symbol.
 */
export function formatEuro(
  value: number,
  locale: Intl.LocalesArgument = "de-DE",
): string {
  return value.toLocaleString(locale, {
    style: "currency",
    currency: "EUR",
    currencySign: "standard",
    currencyDisplay: "symbol",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
